import { FC, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { MessageTimelineItem } from './timeline/MessageTimelineItem';
import { ImageGalleryModal } from './timeline/ImageGalleryModal';
import { MessageResponseDTO, UserResponseDTO } from '../../../type/dto/RequestResponseDTO';

interface MessageTimelineProps {
    messages: MessageResponseDTO[];
    client: UserResponseDTO;
    operator: UserResponseDTO;
}

export const MessageTimeline: FC<MessageTimelineProps> = ({ messages, client, operator }) => {
    const [expandedOffers, setExpandedOffers] = useState<{ [key: string]: boolean }>({});
    const [selectedImage, setSelectedImage] = useState<string | null>(null);

    const toggleOffer = (messageId: string) => {
        setExpandedOffers((prev) => ({
            ...prev,
            [messageId]: !prev[messageId],
        }));
    };

    const getUserName = (userId: number): string => {
        if (client?.id === userId) {
            return `${client.firstName} ${client.lastName}`;
        }
        if (operator?.id === userId) {
            return `${operator.firstName} ${operator.lastName}`;
        }
        return 'Unknown User';
    };

    const getUserRole = (userId: number): string => {
        if (client?.id === userId) return 'Client';
        if (operator?.id === userId) return 'Operator';
        return 'System';
    };

    if (!messages || messages.length === 0) {
        return (
            <Box sx={{ textAlign: 'center', py: 4 }}>
                <Typography variant="body1" color="text.secondary">
                    No messages yet
                </Typography>
            </Box>
        );
    }

    return (
        <Box className="iauto-message-timeline">
            {messages.map((message) => (
                <MessageTimelineItem
                    key={message.id}
                    message={message}
                    userName={getUserName(message.from)}
                    userRole={getUserRole(message.from)}
                    isOfferExpanded={expandedOffers[message.id] || false}
                    onToggleOffer={() => toggleOffer(message.id)}
                    onImageClick={setSelectedImage}
                />
            ))}

            <ImageGalleryModal
                imageUrl={selectedImage}
                onClose={() => setSelectedImage(null)}
            />
        </Box>
    );
};


